
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ProjectFilters/ProjectFilters.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ProjectFilters.html');
        
        var script = require('./ProjectFilters.ts').default;
        module.exports = require('./ProjectFilters.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    